import React, { useEffect } from 'react';
import { useSelector , useDispatch } from 'react-redux';
import {GetAllSpeakers , filterState,DeleteSingleSpeaker} from '../../features/SpeakerCmsSlice/SpeakerCmsSlice'
import DataTable from '../../CmsComponents/DataTableSpeaker/DataTableSpeaker';
import {RiDeleteBin7Line} from 'react-icons/ri'
import {BiEditAlt} from 'react-icons/bi'
import { Link } from 'react-router-dom';


const SpeakerPage = () => {
  const dispatch = useDispatch()

  const deleteSpeaker=async(id)=>{
    dispatch(DeleteSingleSpeaker(id));
    dispatch(filterState(id))
    
  }
  const SpeakerColumns = [
    {
      field: 'id', 
      headerName: 'Sr.No',
      width: 70,
    },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'designation', headerName: 'Designation', width: 200 },
    {field: 'company', headerName: 'Company', width: 200},
    {field: 'linkedIn', headerName: 'LinkedIn', width: 200},
    {
        field: 'speakerImgDash',
        headerName: 'Profile',
        width: 300,
        renderCell: (params) => (
          <img
            src={params.value} // Assuming 'speakerImgDash' contains the image URL
            alt={params.row.name} // You can set the alt text to the speaker's name or any other meaningful description
            style={{ width: '100px', height: 'auto' }}
          />
        ),
      },
        {field: "Action",headerName: "Action",width: 120, renderCell: (params) => 
    <div style={{display:"flex", alignItems:"center", gap:"1rem"}}>
      <Link style={{fontSize:"1.5rem", color:"#3166BB", cursor:"pointer"}} to={`/dashboard/updateSpeaker/${params.row._id}`}><BiEditAlt/></Link>
      <button style={{fontSize:"1.5rem", color:"#3166BB", cursor:"pointer", background:'none', border:'none'}} onClick={()=>deleteSpeaker(params.row._id)}><RiDeleteBin7Line/></button>
    </div>},
  
  ];
  const {Speakers} = useSelector((store)=>store.speakerCms)
  useEffect(()=>{
    dispatch(GetAllSpeakers())
    
  },[dispatch])
  



  return (
    <div>
    {Speakers ? (
      <DataTable columns={SpeakerColumns} data={Speakers} link="/dashboard/create-speaker" />
    ) : (
      <DataTable columns={SpeakerColumns} data={[]} link="/dashboard/create-speaker" />
    )}

    </div>
  )
}

export default SpeakerPage